import { Checkbox, FormControlLabel, Stack, TextField } from "@mui/material";
import { ControlledModificationReasonField } from "@src/appV2/ExperimentalHomeHealth/components/ModificationReasonField";
import { Text } from "@src/appV2/redesign/components/Text";
import { Title } from "@src/appV2/redesign/components/Title";

const SPECIALTIES = [
  "Wound Care",
  "Wound Vac",
  "PICC Line",
  "Dementia",
  "Trache",
  "IV",
  "TPN",
] as const;

export interface Step3Data {
  specialties: string[];
  description: string;
  modificationReason: string;
}

interface Props {
  data: Step3Data;
  onChange: (field: keyof Step3Data, value: string | string[]) => void;
}

export function MobileCreateCaseStep3({ data, onChange }: Props) {
  function toggleSpecialty(specialty: string) {
    const updated = data.specialties.includes(specialty)
      ? data.specialties.filter((s) => s !== specialty)
      : [...data.specialties, specialty];
    onChange("specialties", updated);
  }

  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Title component="h5">Specialties</Title>
        <Stack>
          {SPECIALTIES.map((specialty) => (
            <FormControlLabel
              key={specialty}
              label={specialty}
              control={
                <Checkbox
                  checked={data.specialties.includes(specialty)}
                  onChange={() => {
                    toggleSpecialty(specialty);
                  }}
                />
              }
            />
          ))}
        </Stack>
      </Stack>

      <Stack spacing={0.5}>
        <Title component="h5">Description</Title>
        <Text variant="body2" sx={{ color: "text.secondary", fontStyle: "italic" }}>
          Visible to professionals
        </Text>
        <TextField
          multiline
          minRows={4}
          fullWidth
          value={data.description}
          onChange={(e) => {
            onChange("description", e.target.value);
          }}
          sx={{
            mt: 0.5,
            bgcolor: "background.paper",
            borderRadius: 2,
            "& .MuiOutlinedInput-root": { borderRadius: 2 },
          }}
          inputProps={{ "data-dd-privacy": "mask" }}
        />
      </Stack>

      <ControlledModificationReasonField
        value={data.modificationReason}
        onChange={(value) => {
          onChange("modificationReason", value);
        }}
      />
    </Stack>
  );
}
